// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"radio-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4V18C15.3333 18 8.66667 18 2 18L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 11C18 12.6569 16.6569 14 15 14C13.3431 14 12 12.6569 12 11C12 9.34315 13.3431 8 15 8C16.6569 8 18 9.34315 18 11Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 18V21M18 18V21M22 4V18C15.3333 18 8.66667 18 2 18L2 4L22 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 9H8M6 13H8M18 11C18 12.6569 16.6569 14 15 14C13.3431 14 12 12.6569 12 11C12 9.34315 13.3431 8 15 8C16.6569 8 18 9.34315 18 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Radio2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'radio-2',
    ref,
    icon: element,
  },
));

Radio2Icon.displayName = 'Radio2Icon';

export default Radio2Icon;
